/*
 * operations Reducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 02-Jul-2024
 */

import produce from 'immer'
import { actionTypes } from '../actions/operations'

const ACTION_HANDLERS = {
  [actionTypes.DO_GET_OPERATION_DETAILS_SUCCESS]: produce((draft, action) => {
    draft.operation = action.payload
  }),
  [actionTypes.DO_GET_OPERATION_DETAILS_FAILURE]: produce((draft) => {
    draft.operation = null
  }),
  [actionTypes.DO_GET_OPERATIONS_SUCCESS]: produce((draft, action) => {
    draft.operations = action.payload?.operations || []
    draft.pagination = action.payload?.pagination || initialState.pagination
  }),
  [actionTypes.DO_GET_OPERATIONS_FAILURE]: produce((draft) => {
    draft.operations = []
    draft.pagination = initialState.pagination
  }),
  [actionTypes.DO_GET_PARAMETERS_SUCCESS]: produce((draft, action) => {
    draft.parameters = action.payload
  }),
  [actionTypes.DO_GET_PARAMETERS_FAILURE]: produce((draft) => {
    draft.parameters = null
  }),
  [actionTypes.DO_RESET_OPERATIONS]: () => ({
    ...initialState,
    paymentMethods: [] // Reset esplicito dei payment methods
  }),
  [actionTypes.DO_FETCH_OPERATION_ACTIONS]: produce((draft) => {
    draft.actionsMenu = []
  }),
  [actionTypes.GET_OPERATION_ACTIONS_SUCCESS]: produce((draft, action) => {
    draft.actionsMenu = action.response.actions || []
  }),
  [actionTypes.GET_OPERATION_ACTIONS_FAILURE]: produce((draft) => {
    draft.actionsMenu = []
  }),

  [actionTypes.GET_PAYMENT_METHODS_LIST_SUCCESS]: produce((draft, action) => {
    draft.paymentMethods = action.response?.paymentMethods || []
  }),
  [actionTypes.GET_PAYMENT_METHODS_LIST_FAILURE]: produce((draft) => {
    draft.paymentMethods = []
  }),
  [actionTypes.RETRIVE_OPERATION_TERMINAL_SUCCESS]: produce((draft, action) => {
    draft.operationTerminalId = action.response?.id
  }),
  [actionTypes.DO_RESET_ACTIONS_MENU]: produce((draft) => {
    draft.actionsMenu = []
  }),
  [actionTypes.DO_SET_TIME_STAMP_RESEARCH]: produce((draft, action) => {
    draft.timeStampResearch = action.payload
  })
  // @generator reducer:type:action
}

// The initial state of the operations
export const initialState = {
  operations: null,
  pagination: {
    total: 0,
    page: 1,
    pageSize: 10,
    pageCount: 1
  },
  operation: null,
  parameters: null,
  ordermanagement: [],
  paymentMethods: [],
  operationTerminalId: null,
  timeStampResearch: null
}

const operations = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default operations
